import ClientsService from '@/api/ClientsService.js'
import Vue from 'vue'
export const clientsModule = {
  namespaced: true,
  state: () => ({
    clientsData: [],
    clientsLoadStatus: 'request',
    paginationClientsStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationClientsStateParams.total /
        state.paginationClientsStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.clientsData = [...data]
    },
    create(state, data) {
      state.clientsData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.clientsData.findIndex((x) => x.clients__id == data.id)
      Object.assign(state.clientsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.clientsData.findIndex((x) => x.clients__id == id)
      state.clientsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationClientsStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.clientsLoadStatus = 'request'
    },
    load_success(state) {
      state.clientsLoadStatus = 'success'
    },
    load_error(state) {
      state.clientsLoadStatus = 'error'
    }
  },
  actions: {
    getClientsAll({ commit }, params) {
      commit('load_request')

      ClientsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    getClientsArchiveAll({ commit }, params) {
      commit('load_request')
      ClientsService.getArchiveAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    getClientsBlackListAll({ commit }, params) {
      commit('load_request')

      ClientsService.getBlackListAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createClientsData({ commit }, createData) {
      ClientsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editClientsMultiple({ commit }, { id, dataEdit }) {
      ClientsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteClientsData({ commit }, id) {
      // commit("load_request");
      ClientsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
